import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';

// Landing is not lazy - it's the primary entry, first paint matters.
import { LandingPage } from '@/pages/public/LandingPage';
import { PackagesPage } from '@/pages/public/PackagesPage';

// Scanner input form is a small SEO landing that redirects to
// app.wedpo.com/scanner/report on submit. Lazy so we only pay for it when
// visitors actually open /scanner.
const ScannerHomePage = lazy(() =>
  import('@/pages/scanner/ScannerHomePage').then(m => ({ default: m.ScannerHomePage }))
);
const CookiePolicyPage = lazy(() =>
  import('@/pages/public/CookiePolicyPage').then(m => ({ default: m.CookiePolicyPage }))
);
const CmpInstallPage = lazy(() =>
  import('@/pages/public/CmpInstallPage').then(m => ({ default: m.CmpInstallPage }))
);
const PrivacyPolicyPage = lazy(() =>
  import('@/pages/public/PrivacyPolicyPage').then(m => ({ default: m.PrivacyPolicyPage }))
);
const TermsOfServicePage = lazy(() =>
  import('@/pages/public/TermsOfServicePage').then(m => ({ default: m.TermsOfServicePage }))
);

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/packages" element={<PackagesPage />} />
        <Route path="/pricing" element={<Navigate to="/packages" replace />} />
        <Route
          path="/scanner"
          element={
            <Suspense fallback={<div className="min-h-screen bg-navy" />}>
              <ScannerHomePage />
            </Suspense>
          }
        />
        <Route
          path="/cookie-policy"
          element={
            <Suspense fallback={<div className="min-h-screen bg-cream" />}>
              <CookiePolicyPage />
            </Suspense>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Suspense fallback={<div className="min-h-screen bg-cream" />}>
              <PrivacyPolicyPage />
            </Suspense>
          }
        />
        <Route
          path="/terms-of-service"
          element={
            <Suspense fallback={<div className="min-h-screen bg-cream" />}>
              <TermsOfServicePage />
            </Suspense>
          }
        />
        <Route
          path="/cmp/install"
          element={
            <Suspense fallback={<div className="min-h-screen bg-cream" />}>
              <CmpInstallPage />
            </Suspense>
          }
        />
        {/* Anything else (including legacy app URLs) bounces to the landing. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
